import { render, staticRenderFns } from "./GeoMap.vue?vue&type=template&id=2a52d415&scoped=true&"
import script from "./GeoMap.vue?vue&type=script&lang=js&"
export * from "./GeoMap.vue?vue&type=script&lang=js&"
import style0 from "./GeoMap.vue?vue&type=style&index=0&id=2a52d415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52d415",
  null
  
)

export default component.exports